import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import moment from 'moment';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Golongan</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Informasi Detail Golongan
                                    </CardSubtitle> */}
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Kode Golongan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_group_code !== "" ? this.state.detail.rank_group_code : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama Golongan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_group_name !== "" ? this.state.detail.rank_group_name : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Deskripsi
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_group_description !== "" ? this.state.detail.rank_group_description : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="?" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);